import styles from './HeroSection.module.css';
import { HeroSectionCircle1, HeroSectionCircle2, HeroSectionCircle3, HeroSectionCircle4, VerifyBadge } from '../../../assets/images/icons';
import { t } from 'i18next';

function HeroSection({ title, desc, finish_callback, withOutVerification, ...props }) {
    return (
        <div className={styles.container}>
            <div className={styles.formobile}>
                <img src={HeroSectionCircle1} className={styles.HeroSectionCircle1}></img>
                <img src={HeroSectionCircle2} className={styles.HeroSectionCircle2}></img>
                <img src={HeroSectionCircle3} className={styles.HeroSectionCircle3}></img>
                <img src={HeroSectionCircle4} className={styles.HeroSectionCircle4}></img>
            </div>
            <div className={`${styles.container} ${styles.contentWrapper}`}>
                <div className={`${styles.heroSectionColumn} ${styles.heroSectionCircleForWeb}`}>
                    <img src={HeroSectionCircle1} className={styles.HeroSectionCircle1}></img>
                    <img src={HeroSectionCircle2} className={styles.HeroSectionCircle2}></img>
                    <img src={HeroSectionCircle3} className={styles.HeroSectionCircle3}></img>
                    <img src={HeroSectionCircle4} className={styles.HeroSectionCircle4}></img>
                </div>
                {!withOutVerification &&
                    <div className={`${styles.heroSectionColumn} ${styles.verifyBadgeForWeb}`}>
                        <img src={VerifyBadge} ></img>
                    </div>
                }
                <div className={styles.heroSectionCenter}>
                    <p className={styles.heroTitle}>{title ? title : t('general.UI.verificationTitle')}</p>
                    <p className={styles.heroDesc}>{desc ? desc : t('general.UI.verificationDesc')}</p>
                </div>
                <div className={`${styles.heroSectionColumn} ${styles.verifyBadge}`}>
                    {!withOutVerification && <img src={VerifyBadge} ></img>}
                </div>
            </div>
        </div>
    );
}

export default HeroSection;